import { mediaSkeleton } from '../../../../widgets/plug/Skeleton/components/patterns';

const sortByOrder = (arr, order) => {
    return order.map((i) => arr[i - 1]);
};

export const productMainSkeleton = (w) => {
    const mainArray = [
        {
            content: [
                {
                    type: 'blockSM',
                    width: mediaSkeleton(w, { 1200: 80 }, 100)
                },
                'empty',
                'text',
                'text',
                'text',
                'empty',
                'empty',
                'blockSM',
                'blockSM',
                'blockSM'
            ]
        },
        {
            type: 'circle',
            align: 'center',
            diameter: mediaSkeleton(w, { 767: 40, 1200: 20, 1300: 30 }, w / 14 - 4)
        },
        {
            content: [
                {
                    type: 'blockSM',
                    width: 50
                },
                'empty',
                'title',
                'title',
                'title',
                'empty',
                'empty',
                {
                    type: 'blockXL'
                }
            ]
        }
    ];
    return [
        {
            row: mediaSkeleton(w, { 767: [100, 45, 45], 1200: [30, 30, 30] }, [100, 100, 100]),
            vertical: 'unset',
            items: mediaSkeleton(w, {
                0: sortByOrder(mainArray, [2, 1, 3]),
                1200: mainArray
            })
        }
    ];
};
